/* eslint-disable */
import Vue from 'vue'
import VueScrollTo from './directive';

function plugin (Vue, options) {
    if (plugin.installed) {
      return
    }
  
    Vue.directive('scroll-to', VueScrollTo)
}

export default plugin


// WEBPACK FOOTER //
// ./src/_fdp/core/directive/scroll/index.js